"use client";
import LazyBackgrounds from "@/components/LazyBackgrounds";
import SmoothScrollProvider from "@/components/SmoothScrollProvider";
import { ReactNode } from "react";
import { ThemeProvider } from "../Context/ThemeContext";

interface ProvidersProps {
  children: ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  return (
    <>
      <SmoothScrollProvider />
      <ThemeProvider>
        <LazyBackgrounds />
        {children}
      </ThemeProvider>
    </>
  );
}
